import React, { useState, useEffect, useRef, useContext } from "react";
import { Button, ConfirmDialog, Dialog, InputText, Toast } from "primereact";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";

import AutoCompleteDropdown from "../../../../Base/Components/Form/AutoCompleteDropdown";
import { useForm } from "../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../Base/Services/ToastService";
import Loader from "../../../../Base/Components/Loader/Loader";
import { AuthContext } from "../../../../Base/Context/AuthContext/AuthContext";
import Card from "../../../../Base/Components/Card/Card";
import MultiSelectDropdown from "../../../../Base/Components/Form/MultiSelectDropdown";
import { getAreasAct } from "../../../../Base/API/Global/Areas/AreasRequests";

import { getEstadosCategory } from "../../../../API/Global/Status/StatusRequests";
import { EditarPosicion, EliminarHabilidad, EliminarResponsabilidad, GuardarPosicion, getBeneficios, getBeneficiosPorId, getHabilidades, getNominas, getPosiciones, getResponsabilidades, obtenerCodigo } from "../../../../API/RRHH/Posiciones/PosicionesRequest";
import { getTipoTrabajo } from "../../../../API/Mantenimiento/MantenimientoRequest";

const PosicionesCRUD = ({
  showDialog,
  setShowDialog,
  getInfo,
  selected,
  setSelected,
  modo
}) => {
  const toast = useRef(null);

  const { userAuth } = useContext(AuthContext);
  const [estados, setEstados] = useState([]);
  const [areas, setAreas] = useState([]);
  const [posiciones, setPosiciones] = useState([]);
  const [nominas, setNominas] = useState([]);
  const [beneficios, setBeneficios] = useState([]);
  const [selectedBeneficios, setSelectedBeneficios] = useState([]);
  const [tipoTrabajo, setTipoTrabajo] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responsabilidad, setResponsabilidades] = useState([]);
  const [habilidades, setHabilidades] = useState([]);
  const [dialogEliminar, setDialogEliminar] = useState(false);
  const [dialogEliminar2, setDialogEliminar2] = useState(false);
  const [seleccionada, setSeleccionada] = useState(null);
  const [codigo, setCodigo] = useState([]);

  const initialValues = {
    IdPosicion: -1,
    Posicion: "",
    Description: "",
    IdStatus: selected ? selected?.IdStatus  : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } = useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);
    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const tipoTrabajoTempo = await getTipoTrabajo()
    setTipoTrabajo(tipoTrabajoTempo)

    const b = await getPosiciones();
    let posicionesTempo = b?.filter(i => i?.TienePersonal === true)

    const nominasTempo = await getNominas()
    setNominas(nominasTempo)

    const beneficiosTempo = await getBeneficios()
    setBeneficios(beneficiosTempo)

    if(selected[0]?.IdPosicion > 0){

      posicionesTempo = posicionesTempo?.filter(i=> i?.IdPosicion !== selected[0]?.IdPosicion)
      
      const responsabilidadTempo = await getResponsabilidades(selected[0]?.IdPosicion)
      setResponsabilidades(responsabilidadTempo)
      const habilidadesTempo = await getHabilidades(selected[0]?.IdPosicion)
      setHabilidades(habilidadesTempo)

      const beneficiosTempo = await getBeneficiosPorId(selected[0]?.IdBeneficios)
      setSelectedBeneficios(beneficiosTempo)

      const estadoInicial = modo === "Crear" ? estadosTempo[0] : estadosTempo.find((e) => e.IdStatus === selected[0]?.IdStatus);
      const DependenciaInicial = modo === "Crear" ? b[0] : b.find((e) => e.IdPosicion === selected[0]?.IdDependencia);

      setValues({
        ...selected[0],
        Estado: estadoInicial, 
        Area: areasTempo.find((t) => selected[0]?.IdArea === t.IdArea), 
        TipoT: tipoTrabajoTempo.find((t) => selected[0]?.IdTipoTrabajo === t.IdTipoTrabajo), 
        IdStatus: estadoInicial?.IdStatus, 
        IdDependencia: DependenciaInicial?.IdPosicion,
        Dependencia: DependenciaInicial,
        Codigo: selected[0]?.CodigoPosicion,
      });

    }else{
      const codigoTempo = await obtenerCodigo()
      setCodigo(codigoTempo)
      setValues({
        ...initialValues,
        CodigoPosicion: codigoTempo[0]?.Correlativo
      });
    }

    setPosiciones(posicionesTempo);

    setLoading(false);
  };

  const onHide = () => {
    setShowDialog(false);
    getInfo()
    setSelected([])
    resetForm();
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.Posicion) {
      error.Posicion = true;
      error.error = true;
    }
    if (!values.TipoT || !values.TipoT.IdTipoTrabajo) {
      error.IdTipoTrabajo = true;
      error.error = true;
    }
    if (!values.Nomina.IdNomina && !values?.IdNomina) {
      error.IdNomina = true;
      error.error = true;
    }
    if (!values.Area || !values.Area.IdArea) {
      error.IdArea = true;
      error.error = true;
    }
    if (!values.RangoSalario) {
      error.RangoSalario = true;
      error.error = true;
    }
    if (!values.RangoSalario) {
      error.RangoSalario = true;
      error.error = true;
    }
    if (!values.PerfilOcupacional) {
      error.PerfilOcupacional = true;
      error.error = true;
    }
    if (!values.Objetivo) {
      error.Objetivo = true;
      error.error = true;
    }
    if (!values.Educacion) {
      error.Educacion = true;
      error.error = true;
    }
    if (!values.Conocimiento) {
      error.Conocimiento = true;
      error.error = true;
    }
    if (responsabilidad.length <= 0) {
      error.Responsabilidad = true;
      toastShow(toast, 'warn', 'Advertencia', "Las Responsabilidades son requeridas")
      error.error = true;
    }
    if (habilidades.length <= 0) {
      error.Habilidad = true;
      toastShow(toast, 'warn', 'Advertencia', "Las Habilidades son requeridas")
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregarPosicion = async () => {
    const e = verificarInfo();

    if (!e.error) {

      const Datos = {
        IdPosicion: selected[0]?.IdPosicion ? selected[0]?.IdPosicion : -10,
        IdArea: values.Area?.IdArea,
        IdDependencia: values.Dependencia?.IdPosicion || values?.IdDependencia,
        Posicion: values?.Posicion,
        IdUserCreate: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
        IdTipoTrabajo: values?.TipoT?.IdTipoTrabajo || values?.IdTipoTrabajo,
        IdNomina: values?.Nomina?.IdNomina || values?.IdNomina,
        RangoSalario: values?.RangoSalario,
        IdBeneficios: selectedBeneficios.map(beneficio => beneficio.IdBeneficio).join(","),
        PerfilOcupacional: values?.PerfilOcupacional,
        Objetivo: values?.Objetivo,
        Educacion: values?.Educacion,
        Conocimiento: values?.Conocimiento,
        Responsabilidades: responsabilidad,
        Habilidades: habilidades,
        TienePersonal: values?.TienePersonal
      };

      if(Datos.IdPosicion > 0){
        setLoading(true)
        const resultado = await EditarPosicion(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow(toast,"success","Datos Editados",resultado[0]?.MENSAJE );
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }else{
        const resultado = await GuardarPosicion(Datos);
        if(resultado[0]?.ESTADO === 1){
          toastShow( toast, "success", "Datos Agregados", resultado[0]?.MENSAJE);
          getInfo()
          setTimeout(() => {
            onHide();
            setLoading(false)
          }, 1300);
        }else{
          toastShow(toast,"error","Error",resultado[0]?.MENSAJE);
        }
      }
    }
  };

  const agregarResponsabilidad = () => {
    if (!values?.Responsabilidad){
      toastShow(toast, 'warn', 'Advertencia', 'Responsabilidad es requerida')
      return; 
    } 
  
    const nuevaResponsabilidad = {
      IdResponsabilidad: values?.IdResponsabilidad > 0 ? values?.IdResponsabilidad : -Math.floor(Math.random() * 10000), 
      Responsabilidad: values.Responsabilidad,
    };

    setResponsabilidades([...responsabilidad, nuevaResponsabilidad]);

    setValues({
      ...values,
      IdResponsabilidad: null, 
      Responsabilidad: "", 
    });
  };

  const eliminarResponsabilidad = async(index, resp) => {
    if(resp?.IdResponsabilidad > 0){
      setDialogEliminar(true)
      setSeleccionada(resp)
    }else{
      const nuevasResponsabilidades = [...responsabilidad];
      nuevasResponsabilidades.splice(index, 1); 
      setResponsabilidades(nuevasResponsabilidades); 
    }
  };
  
  const editarResponsabilidad = (index) => {
    const respEdit = responsabilidad[index];
    setValues({
      ...values,
      Responsabilidad: respEdit.Responsabilidad, 
      IdResponsabilidad: respEdit.IdResponsabilidad, 
    });
    
    eliminarResponsabilidad(index);
  };

  const eliminarEjecutar = async () => {
    const a = await EliminarResponsabilidad(seleccionada?.IdResponsabilidad)
    setTimeout(() => {
      toastShow(toast, 'success', 'Eliminado', 'Eliminada correctamene')
      getValoresIniciales()
      setDialogEliminar(false)
      setSeleccionada(null)
    }, 500);
  }

  const agregarHabilidad = () =>{
    if (!values?.Habilidad){
      toastShow(toast, 'warn', 'Advertencia', 'Habilidad es requerida')
      return; 
    } 

    const nuevaHabilidad = {
      IdHabilidad: values?.IdHabilidad > 0 ? values?.IdHabilidad : -Math.floor(Math.random() * 10000), 
      Habilidad: values.Habilidad,
    };
    setHabilidades([...habilidades, nuevaHabilidad]);

    setValues({
      ...values,
      IdHabilidad: null, 
      Habilidad: "", 
    });
  }

  const eliminarHabilidad = async(index, resp) => {
    if(resp?.IdHabilidad > 0){
      setDialogEliminar2(true)
      setSeleccionada(resp)
    }else{
      const nuevasHabilidades = [...habilidades];
      nuevasHabilidades.splice(index, 1); 
      setHabilidades(nuevasHabilidades); 
    }
  };

  const editarHabilidad = (index) => {
    const habilidadEdit = habilidades[index];
    setValues({
      ...values,
      Habilidad: habilidadEdit.Habilidad, 
      IdHabilidad: habilidadEdit.IdHabilidad, 
    });

    eliminarHabilidad(index);
  };

  const eliminarEjecutar2 = async () => {
    const a = await EliminarHabilidad(seleccionada?.IdHabilidad)
    setTimeout(() => {
      toastShow(toast, 'success', 'Eliminado', 'Eliminada correctamene')
      getValoresIniciales()
      setDialogEliminar2(false)
      setSeleccionada(null)
    }, 500);
  }

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={modo === "Crear" ? "Guardar" : "Modificar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {agregarPosicion();}}
      />
    </React.Fragment>
  );

  const DialogFooter2 = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => setDialogEliminar(false)}
      />
      <Button
        label={'OK'}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {eliminarEjecutar();}}
      />
    </React.Fragment>
  );

  const DialogFooter3 = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => setDialogEliminar2(false)}
      />
      <Button
        label={'OK'}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {eliminarEjecutar2();}}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = modo === "Crear" ? "Agregar Posición" : "Modificar Posición";

  return (
    <div>
      <Dialog
        visible={showDialog}
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{height: '100%', width: '72%'}}
      >
        <Toast ref={toast} />
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div>
            <div className="d-flex mx-4">
              <div div className="field col-3 me-2 mt-2">
                <span className="p-float-label">
                  <InputText
                    name="CodigoPosicion"
                    value={values.CodigoPosicion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    disabled
                    className={error.CodigoPosicion ? "p-invalid" : ""}
                  />
                  <label htmlFor="CodigoPosicion">Código</label>
                </span>
              </div>

              <div className="field col-3 me-2  mt-2">
                <span className="p-float-label">
                  <InputText
                    name="Posicion"
                    value={values.Posicion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.Posicion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Posición">Posición</label>
                </span>
              </div>

              <div className="field col-3 me-2  mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"TipoT"}
                    value={values.TipoT}
                    items={tipoTrabajo}
                    field={"TipoTrabajo"}
                    label={"Tipo Trabajo"}
                    handleInputChange={handleInputChange}
                    className={error.IdTipoTrabajo ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-3 me-2 mt-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Nomina"}
                    value={values.Nomina}
                    items={nominas}
                    field={"Nomina"}
                    label={"Nomina"}
                    handleInputChange={handleInputChange}
                    className={error.IdNomina ? "p-invalid" : ""}
                  />
                </span>
              </div>

            </div>

            <div className="d-flex mx-4 mt-4">

              <div className="field col-3 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Area"}
                    value={values.Area}
                    items={areas}
                    field={"Area"}
                    label={"Departamento"}
                    handleInputChange={handleInputChange}
                    className={error.IdArea ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-3 me-2">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Dependencia"}
                    value={values.Dependencia}
                    items={posiciones}
                    field={"Posicion"}
                    label={"Dependencia"}
                    handleInputChange={handleInputChange}
                    className={error.IdDependencia ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div div className="field col-3 me-2">
                <span className="p-float-label">
                  <InputNumber
                    name="RangoSalario"
                    value={values.RangoSalario}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    className={error.RangoSalario ? "p-invalid" : ""}
                    minFractionDigits={2}
                  />
                  <label htmlFor="RangoSalario">Rango de Salario</label>
                </span>
              </div>

              <div className="field col-3 me-2">
                <span className="p-float-label">
                  <MultiSelectDropdown
                    name="Personal"
                    value={selectedBeneficios}
                    setValue={setSelectedBeneficios}
                    items={beneficios}
                    field="Beneficio"
                    placeholder="Seleccione Beneficios"
                    label="Beneficios"
                  />
                </span>
              </div>

            </div>

            <div className="d-flex mx-4 mt-4">
              <div div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="PerfilOcupacional"
                    value={values.PerfilOcupacional}
                    onChange={handleInputChange}
                    rows={5}
                    style={{ width: "100%" }}
                    className={error.PerfilOcupacional ? "p-invalid" : ""}
                  />
                  <label htmlFor="PerfilOcupacional">Perfil Ocupacional</label>
                </span>
              </div>

              <div div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="Objetivo"
                    value={values.Objetivo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    rows={5}
                    className={error.Objetivo ? "p-invalid" : ""}
                  />
                  <label htmlFor="Objetivo">Objetivo del Puesto</label>
                </span>
              </div>
            </div>

            <div className="d-flex mx-4 mt-4">
              <div div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="Educacion"
                    value={values.Educacion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    rows={5}
                    className={error.Educacion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Educacion">Educación y Formación</label>
                </span>
              </div>

              <div div className="field col-6 me-2">
                <span className="p-float-label">
                  <InputTextarea
                    name="Conocimiento"
                    value={values.Conocimiento}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    rows={5}
                    className={error.Conocimiento ? "p-invalid" : ""}
                  />
                  <label htmlFor="Conocimiento">Conocimiento y Experiencia</label>
                </span>
              </div>
            </div>

            <div className="d-flex mx-4 gap-2">
              <div className="col-6">
                <Card
                  titulo="Habilidades, Destrezas y Requisitos"
                  style={{ width: "100%" }}
                  contenido={
                    <>
                      <div className="d-flex gap-1">
                        <div className="field me-2" style={{ width: "90%" }}>
                          <span className="p-float-label">
                            <InputText
                              name="Habilidad"
                              value={values.Habilidad}
                              onChange={handleInputChange}
                              style={{ width: "100%" }}
                              className={error.Habilidad ? "p-invalid" : ""}
                            />
                          </span>
                        </div>
                        <Button
                          icon="pi pi-plus"
                          type="button"
                          tooltip={"Agregar Habilidad"}
                          tooltipOptions={{ position: "top" }}
                          onClick={agregarHabilidad}
                        />
                      </div>

                      <div style={{ maxHeight: "170px", overflowY: "auto", maxWidth: '645px' }}>
                        <ul className="mt-3">
                          {habilidades.map((resp, index) => (
                            <li key={index} className="p-2 border-bottom d-flex justify-content-between align-items-center">
                              <span>&#8226; {resp.Habilidad}</span>
                              <div className="d-flex gap-2">
                                <Button
                                  icon="pi pi-pencil"
                                  className="p-button-text"
                                  type="button"
                                  onClick={() => editarHabilidad(index)} 
                                />
                                <Button
                                  icon="pi pi-times"
                                  className="p-button-text p-button-danger"
                                  type="button"
                                  onClick={() => eliminarHabilidad(index, resp)} 
                                />
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>

                    </>
                  }
                />
              </div>

              <div className="col-6">
                <Card
                  titulo="Deberes y Responsabilidades"
                  style={{ width: "100%" }}
                  contenido={
                    <>
                      <div className="d-flex gap-1">
                        <div className="field me-2" style={{ width: "90%" }}>
                          <span className="p-float-label">
                            <InputText
                              name="Responsabilidad"
                              value={values.Responsabilidad}
                              onChange={handleInputChange}
                              style={{ width: "100%" }}
                              className={error.Responsabilidad ? "p-invalid" : ""}
                            />
                          </span>
                        </div>
                        <Button
                          icon="pi pi-plus"
                          type="button"
                          tooltip={"Agregar Responsabilidad"}
                          tooltipOptions={{ position: "top" }}
                          onClick={agregarResponsabilidad}
                        />
                      </div>

                      <div style={{ maxHeight: "170px", overflowY: "auto", maxWidth: '645px' }}>
                        <ul className="mt-3">
                          {responsabilidad.map((resp, index) => (
                            <li key={index} className="p-2 border-bottom d-flex justify-content-between align-items-center">
                              <span>&#8226; {resp.Responsabilidad}</span>
                              <div className="d-flex gap-2">
                                <Button
                                  icon="pi pi-pencil"
                                  className="p-button-text"
                                  type="button"
                                  onClick={() => editarResponsabilidad(index)} 
                                />
                                <Button
                                  icon="pi pi-times"
                                  className="p-button-text p-button-danger"
                                  type="button"
                                  onClick={() => eliminarResponsabilidad(index, resp)} 
                                />
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>

                    </>
                  }
                />
              </div>
            </div>

            <div className="d-flex mx-4 mt-4">

              <div className="field col-3 me-2">

              </div>

              <div className="field col-3 me-2">

              </div>

              <div div className="field col-3 me-2">

              </div>

              <div className="field col-3 me-2">
                  <span className="mx-2 mt-2">Tiene Personal a cargo</span>
                  <Checkbox
                    id="TienePersonal"
                    name="TienePersonal"
                    checked={values.TienePersonal}
                    onChange={handleInputChange}
                  />
              </div>

            </div>

          </div>
        </div>
      </Dialog>


      <Dialog
        visible={dialogEliminar}
        footer={DialogFooter2}
        onHide={() => {
          setDialogEliminar(false)
          setSeleccionada(null)
        }}
        header='Eliminar'
        style={{ width: '20%'}}
      >
        <div>
          <h6>¿Está seguro de eliminar la responsabilidad?</h6>
        </div>
      </Dialog>

      <Dialog
        visible={dialogEliminar2}
        footer={DialogFooter3}
        onHide={() => {
          setDialogEliminar2(false)
          setSeleccionada(null)
        }}
        header='Eliminar'
        style={{ width: '20%'}}
      >
        <div>
          <h6>¿Está seguro de eliminar la habilidad?</h6>
        </div>
      </Dialog>

      
    </div>
  );
};

export default PosicionesCRUD;
